var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconNewAccountRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 39,
    viewBox: "0 0 42 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    clipPath: "url(#clip0_1616_21344)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M27.2432 22.0086C26.6945 21.7504 26.135 21.5343 25.5701 21.3288C28.7711 19.2418 30.8854 15.6791 30.8854 11.642C30.8854 5.21757 25.554 0 19.0068 0C12.4596 0 7.12822 5.21757 7.12822 11.6368C7.12822 15.6843 9.24785 19.247 12.4542 21.3341C5.19687 23.9586 0 30.7784 0 38.7892H3.16869C3.16869 30.2355 10.2754 23.2735 19.0068 23.2735C21.4116 23.2735 23.7249 23.79 25.8714 24.8019L27.2486 22.0086H27.2432ZM10.2969 11.6368C10.2969 6.9304 14.2026 3.10419 19.0068 3.10419C23.8109 3.10419 27.7167 6.9304 27.7167 11.6368C27.7167 16.3431 23.8109 20.1693 19.0068 20.1693C14.2026 20.1693 10.2969 16.3431 10.2969 11.6368Z",
    fill: "#E21F26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M33.6829 22.7096C29.0993 22.7096 25.3657 26.3619 25.3657 30.8574C25.3657 35.353 29.0939 39.0053 33.6829 39.0053C38.2718 39.0053 42 35.353 42 30.8574C42 26.3619 38.2718 22.7096 33.6829 22.7096ZM33.6829 36.6758C30.4066 36.6758 27.7436 34.067 27.7436 30.8574C27.7436 27.6478 30.4066 25.0391 33.6829 25.0391C36.9592 25.0391 39.6222 27.6478 39.6222 30.8574C39.6222 34.067 36.9592 36.6758 33.6829 36.6758Z",
    fill: "#E21F26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M34.8838 28H33.1162V30.1162H31V31.8838H33.1162V34H34.8838V31.8838H37V30.1162H34.8838V28Z",
    fill: "#E21F26"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1616_21344"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 39,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNewAccountRed);
export default __webpack_public_path__ + "static/media/icon_new_account_red.2f61b2d43a39e5553b05cfad52a987ed.svg";
export { ForwardRef as ReactComponent };